// src/components/Policies/PrivacyPolicy.jsx
import React from 'react';
import styles from './Policies.module.css';
import { Link } from 'react-router-dom';
import { useTheme } from './context/ThemeContext';


const PrivacyPolicy = () => {
  const { theme } = useTheme();

  return (
    <div className={`${styles.policyContainer} ${theme === "dark" ? "dark" : ""} ${styles[theme]}`}>
      <div className={styles.policyHeader}>
        <h1 className={styles.title}>Privacy Policy</h1>
        <p className={styles.effectiveDate}>Effective Date: December 2025</p>
      </div>
  
      <div className={styles.policyContent}>
        <div className={styles.intro}>
          <p>
            This Privacy Policy describes how Pixel Moon Store (operated by GJ Mart) collects, uses, processes, and
            protects your personal data.
          </p>
        </div>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>1. Information Collection and Use</h2>
          <div className={styles.subsection}>
            <h3>1.1 Information Collected</h3>
            <p>
              We collect personal information (name, email, contact, game IDs, transaction data, usage data) necessary
              to deliver services, process orders, and improve user experience.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>1.2 Purpose of Processing</h3>
            <p>
              Collected information is used solely for order fulfillment, compliance with applicable laws, fraud
              prevention, service improvement, and customer support.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>1.3 Data Retention</h3>
            <p>
              Personal data is retained only for as long as necessary to fulfil orders, comply with legal obligations,
              resolve disputes, and enforce agreements.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>2. Data Security and Sharing</h2>
          <div className={styles.subsection}>
            <h3>2.1 Payment Security</h3>
            <p>
              Pixel Moon Store does not collect or store full card numbers, CVV, or sensitive payment credentials.
              Payments are securely handled by authorized PCI-DSS compliant partners.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.2 Data Security Measures</h3>
            <p>
              We implement appropriate technical and organizational measures to protect personal data against accidental
              or unlawful destruction, loss, alteration, unauthorized disclosure, or access. This includes using data
              encryption, secure servers, and access control mechanisms to safeguard your information. In the event of a
              data breach affecting personal data, affected users will be notified in accordance with applicable law.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.3 Data Sharing</h3>
            <p>
              We share data only with trusted third-party partners (payment processors, delivery services) strictly for
              the purpose of fulfilling services, or when required by law enforcement or judicial order. We do not sell
              personal data to third parties.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>2.4 International Data Transfers</h3>
            <p>
              Where services or partners are located outside India, personal data may be processed in other
              jurisdictions while ensuring reasonable safeguards in accordance with applicable law.
            </p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>3. Cookies & Analytics</h2>
          <p>
            We use cookies and similar tracking technologies to personalize experience and improve performance. Users
            may manage cookie settings via their browser or platform options.
          </p>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>4. User Rights and Compliance</h2>
          <div className={styles.subsection}>
            <h3>4.1 User Rights</h3>
            <p>
              Users may request access, correction, or deletion of their personal data by contacting the Grievance
              Officer, subject to applicable legal and data retention requirements.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.2 Grievance Redressal (India Compliance)</h3>
            <p>
              In accordance with the Information Technology Act, 2000 and associated intermediary rules, we have a
              designated Grievance Officer to address user complaints and disputes.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.3 Children's Privacy</h3>
            <p>
              We do not knowingly collect personal data from individuals below the applicable minimum age. If such data
              is identified, it will be deleted promptly.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.4 Policy Updates</h3>
            <p>
              We reserve the right to update this policy. Continued use of the services implies acceptance of the
              updated terms.
            </p>
          </div>
          <div className={styles.subsection}>
            <h3>4.5 Requests Submission</h3>
            <p>Requests may be submitted via email to admin@pixelmoonstore.in</p>
          </div>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Grievance Officer</h2>
          <p>
            In accordance with the Information Technology Act, 2000 and the Information Technology (Intermediary
            Guidelines and Digital Media Ethics Code) Rules, we have appointed a Grievance Officer to address user
            concerns:
          </p>
          <div className={styles.contactCard}>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Name:</span>
              <span className={styles.contactValue}>Gaurav Jadhav</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Email:</span>
              <span className={styles.contactValue}>admin@pixelmoonstore.in</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Contact:</span>
              <span className={styles.contactValue}>+91 7588903499</span>
            </div>
          </div>
          <p className={styles.note}>Complaints will be acknowledged within 24–48 business hours.</p>
        </section>
  
        <section className={styles.section}>
          <h2 className={styles.sectionTitle}>Contact Information</h2>
          <div className={styles.contactCard}>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Name:</span>
              <span className={styles.contactValue}>Gaurav Jadhav</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Email:</span>
              <span className={styles.contactValue}>admin@pixelmoonstore.in</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Contact:</span>
              <span className={styles.contactValue}>+91 7588903499</span>
            </div>
            <div className={styles.contactRow}>
              <span className={styles.contactLabel}>Address:</span>
              <span className={styles.contactValue}>Pune, Maharashtra, India</span>
            </div>
          </div>
          <p className={styles.note}>We offer 24/7 support with our chatbot.</p>
        </section>
  
        <div className={styles.policyLinks}>
          <Link to="/terms" className={styles.policyLink}>
            Terms & Conditions
          </Link>
          <Link to="/refund" className={styles.policyLink}>
            Refund & Shipping Policy
          </Link>
        </div>
      </div>
    </div>
  
  );
}

export default PrivacyPolicy;